import React, { useReducer, createContext, FunctionComponent, useContext } from 'react';
import { PlayerUIReducer } from './reducer';
import { PlayerUIState, IPlayerUIState } from './state';

const PlayerUIContext = createContext(null);

const PlayerUIContextProvider: FunctionComponent = ({ children }) => {
    const [state, dispatch] = useReducer(PlayerUIReducer, PlayerUIState);

    return (
        <PlayerUIContext.Provider value={{ state, dispatch }}>{children}</PlayerUIContext.Provider>
    );
};

PlayerUIContextProvider.displayName = 'PlayerUIContextProvider';

export const usePlayerUIContext = () => useContext(PlayerUIContext);
export * from './actions';
export { PlayerUIState, IPlayerUIState, PlayerUIContextProvider, PlayerUIContext };
